function Button(data) {
    return (
        <button 
            onClick={data.onClick} disabled={data.disabled?true:false} 
            className={`button is-size-4 is-fullwidth is-outlined dbutton ${data.selected&&"dbutton-active"}`}
        >
              {data.children}
        </button>
    )
}

export default Button;